import { InputMask } from '@react-input/mask';
import { TimePicker, TimePickerProps } from "antd";
import dayjs from 'dayjs';
import customParseFormat from "dayjs/plugin/customParseFormat";
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Select, { StylesConfig } from "react-select";
import * as Yup from "yup";
import TextField from '../../../../core/common/textFields/TextField';
import { removeImage, setImage } from '../../../../Features/commonSlice';
import { RootState } from '../../../../store';
import { svgIcons } from '../../../../style/fonts/SvgIcons';

const ContactWizardData = ({ projectData, showContactUpdatedData, getContactLookup, toogle, setToogle, formik, getContactbyId, setShowContactData }: any) => {

  const location = useLocation();
  const contactId = useParams();
  const isEditing = location.pathname.includes('EditContacts')
  const viewOnly = location.pathname.includes('ViewContacts')
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hideShowDiv = () => {
    setToogle((prev: any) => !prev)
  }
  const customStyles: StylesConfig = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "rgba(177, 31, 40, 1)",
      },
    }),
  };
  const [updateId, setUpdateId] = useState(0);
  const imageUrl = useSelector((state: RootState) => state.common?.imageUrl);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const [primaryHEmailErr, setPrimaryHEmailErr] = useState(false)
  const [primaryWEmailErr, setPrimaryWEmailErr] = useState(false)
  const [secHEmailErr, setSecHEmailErr] = useState(false)
  const [secWEmailErr, setSecWEmailErr] = useState(false)

  dayjs.extend(customParseFormat);

  const onChangeTime: TimePickerProps['onChange'] = (time, timeString) => {
    const formattedTime = time ? dayjs(time).format("h:mm A") : '';
    formik.setFieldValue('primaryContactVMs.perferredTime', formattedTime);

  };
  const onChangeTimeSecondary: TimePickerProps['onChange'] = (time, timeString) => {
    const formattedTime = time ? dayjs(time).format("h:mm A") : '';
    formik.setFieldValue('secondaryContactVMs.perferredTime', formattedTime);

  };

  const handleContactType = (selectedOption: any) => {
    formik.setFieldValue(' inquiryMethod', selectedOption);
  };
  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      dispatch(setImage(imageUrl));
      formik.setFieldValue('imageUrl', imageUrl);
      formik.setFieldValue('file', file);
    }
  };
  const handleRemoveImage = () => {
    dispatch(removeImage());
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };



  // useEffect(() => {
  //   if (updateIsSuccess) {
  //     toast.success(updatedata?.message);
  //     navigate('/contacts')

  //   }

  // }, [ updateIsSuccess]);

  // useEffect(() => {
  //   if (updateIsError && updateError) {
  //     let errorMessage: string = 'Something went wrong';

  //     if ('data' in updateError && updateError.data && typeof updateError.data === 'object' && 'message' in updateError.data) {
  //       errorMessage = (updateError.data as { message: string }).message;
  //     }
  //     toast.error(errorMessage);
  //   }
  // }, [ updateIsError, updateError]);


  useEffect(() => {
    if (getContactbyId?.result && Object.keys(getContactbyId?.result).length > 0) {
      formik.setValues({ ...getContactbyId?.result });
    } else {
      // setUpdateId(0);
    }
  }, [getContactbyId]);

  useEffect(() => {
    if (setShowContactData) {
      setShowContactData(formik)
    }
  }, [setShowContactData, formik.values])

  useEffect(() => {
    if (showContactUpdatedData) {
      formik.setValues({ ...showContactUpdatedData })
    }
  }, [showContactUpdatedData])


  const handleBack = () => {
    navigate('/Contacts')
  }
  const items = [
    {
      tooltipLabel: 'Back',
      icon: svgIcons.BackIcon,
      onClick: () => handleBack(),
    },
  ];

  return (
    <div className='row mt-3'>
      <h5 className=' mb-2'>Primary Contact</h5>
      <>
        <div className="col-md-12">
          <div className="form-wrap">
            <label className="input-label">
              Contact Type{" "} <span className="text-danger">*</span>
            </label>
            <Select
              styles={customStyles}
              className="select"
              options={getContactLookup?.result?.contactTypes?.map((option: any) => ({
                label: option?.name,
                value: option?.id
              }))}
              value={
                formik.values?.primaryContactVMs?.contactType?.id
                  ? {
                    value: formik.values?.primaryContactVMs?.contactType?.id,
                    label: formik.values?.primaryContactVMs?.contactType?.name || '',
                  }
                  : null
              }
              isDisabled
              onChange={(selectedOption: any) => {
                formik.setFieldValue('primaryContactVMs.contactType.id', selectedOption.value);
                formik.setFieldValue('primaryContactVMs.contactType.name', selectedOption.label);

              }}
            />
          </div>
          {/* {formik.touched.contactType && formik.errors.contactType && (
            <div className="error">{formik.errors.contactType?.id}</div>
          )} */}
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <TextField
              label="Company Name"
              type="text"
              {...formik.getFieldProps("primaryContactVMs.companyName")}
              disabled={viewOnly}
            />
          </div>

        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <label className="input-label">
              Salutation{" "} <span className="text-danger">*</span>
            </label>
            <Select
              styles={customStyles}
              className="select"
              options={getContactLookup?.result?.salutationTypes?.map((option: any) => ({
                label: option?.name,
                value: option?.id
              }))}
              value={
                formik.values?.primaryContactVMs?.salutation?.id
                  ? {
                    value: formik.values?.primaryContactVMs?.salutation?.id,
                    label: formik.values?.primaryContactVMs?.salutation?.name || '',
                  }
                  : null
              }
              isDisabled={viewOnly}
              onChange={(selectedOption: any) => {
                formik.setFieldValue('primaryContactVMs.salutation.id', selectedOption.value);
                formik.setFieldValue('primaryContactVMs.salutation.name', selectedOption.label);

              }}
            />
          </div>
          {/* {formik.touched.salutation?.id && formik.errors.salutation?.id && (
            <div className="error">{formik.errors.salutation?.id}</div>
          )} */}
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <TextField
              label=" First Name"
              type="text"
              required
              {...formik.getFieldProps("primaryContactVMs.firstName")}
              disabled={viewOnly}
            />
          </div>
          {/* {formik.touched.firstName && formik.errors.firstName && (
            <div className="error">{formik.errors.firstName}</div>
          )} */}
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <TextField
              label="Last Name"
              type="text"
              required
              {...formik.getFieldProps("primaryContactVMs.lastName")}
              disabled={viewOnly}
            />
          </div>
          {/* {formik.touched.lastName && formik.errors.lastName && (
            <div className="error">{formik.errors.lastName}</div>
          )} */}
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <TextField
              label="Address As"
              type="text"
              {...formik.getFieldProps("primaryContactVMs.addressAs")}
              disabled={viewOnly}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <label className="input-label">Marital Status</label>
            <Select
              styles={customStyles}
              className="select"
              options={getContactLookup?.result?.maritalStatusTypes?.map((option: any) => ({
                label: option?.name,
                value: option?.id
              }))}
              value={
                formik.values?.primaryContactVMs?.maritalStatus?.id
                  ? {
                    value: formik.values?.primaryContactVMs?.maritalStatus?.id,
                    label: formik.values?.primaryContactVMs?.maritalStatus?.name || '',
                  }
                  : null
              }
              isDisabled={viewOnly}
              onChange={(selectedOption: any) => {
                formik.setFieldValue('primaryContactVMs.maritalStatus.id', selectedOption.value);
                formik.setFieldValue('primaryContactVMs.maritalStatus.name', selectedOption.label);

              }}
            />
          </div>
        </div>
        <h5 className=' mb-2'>
          Contact Information
        </h5>
        <div className="col-md-6">
          <div className="form-wrap">
            <label className='input-label'>
              Home Phone
            </label>
            <InputMask mask="+1(___)___-____"
              replacement={{ _: /\d/ }}
              className="form-control"
              {...formik.getFieldProps("primaryContactVMs.homePhone")}
              disabled={viewOnly}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <label className='input-label'>
              Work Phone
            </label>
            <InputMask mask="+1(___)___-____"
              replacement={{ _: /\d/ }}
              className="form-control"
              {...formik.getFieldProps("primaryContactVMs.workPhone")}
              disabled={viewOnly}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <label className='input-label'>
              Cell Phone
            </label>
            <InputMask mask="+1(___)___-____"
              replacement={{ _: /\d/ }}
              className="form-control"
              {...formik.getFieldProps("primaryContactVMs.cellPhone")}
              disabled={viewOnly}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <label className='input-label'>
              Fax
            </label>
            <InputMask mask="+1(___)___-____"
              replacement={{ _: /\d/ }}
              className="form-control"
              {...formik.getFieldProps("primaryContactVMs.fax")}
              disabled={viewOnly}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <label className='input-label'>
              Pager
            </label>
            <InputMask mask="+1(___)___-____"
              replacement={{ _: /\d/ }}
              className="form-control"
              {...formik.getFieldProps("primaryContactVMs.pager")}
              disabled={viewOnly}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <TextField
              label="Home Email"
              type="email"
              onChange={(e) => {
                const value = e.target.value.trim();
                formik.setFieldValue("primaryContactVMs.homeEmail", value);

                if (value && !emailRegex.test(value)) {
                  setPrimaryHEmailErr(true)
                }
                else {
                  setPrimaryHEmailErr(false)
                }
              }}
              onBlur={formik.handleBlur}
              disabled={viewOnly}
              value={formik.values?.primaryContactVMs?.homeEmail}

            />
          </div>
          {primaryHEmailErr &&
            <p className='mb-0 color-red'>
              Invalid Email Format
            </p>
          }
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <TextField
              label="Work Email "
              type="email"
              onChange={(e) => {
                const value = e.target.value.trim();
                formik.setFieldValue("primaryContactVMs.workEmail", value);

                if (value && !emailRegex.test(value)) {
                  setPrimaryWEmailErr(true)
                }
                else {
                  setPrimaryWEmailErr(false)
                }
              }}
              onBlur={formik.handleBlur}
              disabled={viewOnly}
              value={formik.values?.primaryContactVMs?.workEmail}

            />
          </div>
          {primaryWEmailErr &&
            <p className='mb-0 color-red'>
              Invalid Email Format
            </p>
          }
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <label className="input-label">Preferred Method
              {/* <span className="text-danger">*</span> */}
            </label>
            <Select
              styles={customStyles}
              className="select"
              options={getContactLookup?.result?.preferredMethodTypes?.map((option: any) => ({
                label: option?.name,
                value: option?.id
              }))}
              value={
                formik.values?.primaryContactVMs?.preferredMethod?.id
                  ? {
                    value: formik.values?.primaryContactVMs?.preferredMethod?.id,
                    label: formik.values?.primaryContactVMs?.preferredMethod?.name || '',
                  }
                  : null
              }
              isDisabled={viewOnly}
              onChange={(selectedOption: any) => {
                formik.setFieldValue('primaryContactVMs.preferredMethod.id', selectedOption.value);
                formik.setFieldValue('primaryContactVMs.preferredMethod.name', selectedOption.label);
              }}
            />
          </div>
        </div>
        <div className="col-md-6">
          <label className="input-label">
            Pref.Times
          </label>
          <TimePicker
            placeholder="Select Time"
            className="form-control datetimepicker-time"
            onChange={onChangeTime}
            // value={aptResultbyId?.result?.startTime}
            // defaultOpenValue={dayjs("12:00 AM", "h:mm A")}
            value={
              formik.values.primaryContactVMs?.perferredTime &&
                dayjs(formik.values.primaryContactVMs?.perferredTime, "h:mm A").isValid()
                ? dayjs(formik.values.primaryContactVMs?.perferredTime, "h:mm A")
                : null
            }
            format="h:mm A"
            use12Hours
            disabled={viewOnly}

          />
        </div>
      </>
      {formik.values?.secondaryContactVMs?.contactType?.id === undefined ?
        <div className='d-flex justify-content-end'>
          <h6 className='color-red p-3  text-decoration-underline cursor-pointer' onClick={hideShowDiv}> {toogle ? " Remove this secondary contact" : "Add secondary contact"}</h6>
        </div>
        : formik.values?.secondaryContactVMs?.contactType?.id ?
          <div className='d-flex justify-content-end'>

          </div>
          :
          <div className='d-flex justify-content-end'>
            <h6 className='color-red p-3  text-decoration-underline cursor-pointer' onClick={hideShowDiv}> {"Add secondary contact"}</h6>
          </div>
      }
      {toogle === true &&
        <>
          <h5 className='mt-2 mb-2 '>Secondary Contact</h5>
          <div className="col-md-12">
            <div className="form-wrap">
              <label className="input-label">
                Contact Type{" "} <span className="text-danger">*</span>
              </label>
              <Select
                styles={customStyles}
                className="select"
                options={getContactLookup?.result?.contactTypes?.map((option: any) => ({
                  label: option?.name,
                  value: option?.id
                }))}
                value={
                  formik.values?.secondaryContactVMs?.contactType?.id
                    ? {
                      value: formik.values?.secondaryContactVMs?.contactType?.id,
                      label: formik.values?.secondaryContactVMs?.contactType?.name || '',
                    }
                    : null
                }
                isDisabled={viewOnly}
                onChange={(selectedOption: any) => {
                  formik.setFieldValue('secondaryContactVMs.contactType.id', selectedOption.value);
                  formik.setFieldValue('secondaryContactVMs.contactType.name', selectedOption.label);

                }}
              />
            </div>
            {formik.touched.contactType && formik.errors.contactType && (
              <div className="error">{formik.errors.contactType?.id}</div>
            )}
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <TextField
                label=" Company Name"
                type="text"
                {...formik.getFieldProps("secondaryContactVMs.companyName")}
                disabled={viewOnly}
              />
            </div>

          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <label className="input-label">
                Salutation{" "} <span className="text-danger">*</span>
              </label>
              <Select
                styles={customStyles}
                className="select"
                options={getContactLookup?.result?.salutationTypes?.map((option: any) => ({
                  label: option?.name,
                  value: option?.id
                }))}
                value={
                  formik.values?.secondaryContactVMs?.salutation?.id
                    ? {
                      value: formik.values?.secondaryContactVMs?.salutation?.id,
                      label: formik.values?.secondaryContactVMs?.salutation?.name || '',
                    }
                    : null
                }
                isDisabled={viewOnly}
                onChange={(selectedOption: any) => {
                  formik.setFieldValue('secondaryContactVMs.salutation.id', selectedOption.value);
                  formik.setFieldValue('secondaryContactVMs.salutation.name', selectedOption.label);

                }}
              />
            </div>
            {formik.touched.salutation?.id && formik.errors.salutation?.id && (
              <div className="error">{formik.errors.salutation?.id}</div>
            )}
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <TextField
                label=" First Name"
                type="text"
                required
                {...formik.getFieldProps("secondaryContactVMs.firstName")}
                disabled={viewOnly}
              />
            </div>
            {formik.touched.firstName && formik.errors.firstName && (
              <div className="error">{formik.errors.firstName}</div>
            )}
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <TextField
                label="Last Name"
                type="text"
                required
                {...formik.getFieldProps("secondaryContactVMs.lastName")}
                disabled={viewOnly}
              />
            </div>
            {formik.touched.lastName && formik.errors.lastName && (
              <div className="error">{formik.errors.lastName}</div>
            )}
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <TextField
                label="Address As"
                type="text"
                {...formik.getFieldProps("secondaryContactVMs.addressAs")}
                disabled={viewOnly}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <label className="input-label">Marital Status</label>
              <Select
                styles={customStyles}
                className="select"
                options={getContactLookup?.result?.maritalStatusTypes?.map((option: any) => ({
                  label: option?.name,
                  value: option?.id
                }))}
                value={
                  formik.values?.secondaryContactVMs?.maritalStatus?.id
                    ? {
                      value: formik.values?.secondaryContactVMs?.maritalStatus?.id,
                      label: formik.values?.secondaryContactVMs?.maritalStatus?.name || '',
                    }
                    : null
                }
                isDisabled={viewOnly}
                onChange={(selectedOption: any) => {
                  formik.setFieldValue('secondaryContactVMs.maritalStatus.id', selectedOption.value);
                  formik.setFieldValue('secondaryContactVMs.maritalStatus.name', selectedOption.label);

                }}
              />
            </div>
          </div>
          <h5 className=' mb-2'>
            Contact Information
          </h5>
          <div className="col-md-6">
            <div className="form-wrap">
              <label className='input-label'>
                Home Phone
              </label>
              <InputMask mask="+1(___)___-____"
                replacement={{ _: /\d/ }}
                className="form-control"
                {...formik.getFieldProps("secondaryContactVMs.homePhone")}
                disabled={viewOnly}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <label className='input-label'>
                Work Phone
              </label>
              <InputMask mask="+1(___)___-____"
                replacement={{ _: /\d/ }}
                className="form-control"
                {...formik.getFieldProps("secondaryContactVMs.workPhone")}
                disabled={viewOnly}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <label className='input-label'>
                Cell Phone
              </label>
              <InputMask mask="+1(___)___-____"
                replacement={{ _: /\d/ }}
                className="form-control"
                {...formik.getFieldProps("secondaryContactVMs.cellPhone")}
                disabled={viewOnly}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <label className='input-label'>
                Fax
              </label>
              <InputMask mask="+1(___)___-____"
                replacement={{ _: /\d/ }}
                className="form-control"
                {...formik.getFieldProps("secondaryContactVMs.fax")}
                disabled={viewOnly}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <label className='input-label'>
                Pager
              </label>
              <InputMask mask="+1(___)___-____"
                replacement={{ _: /\d/ }}
                className="form-control"
                {...formik.getFieldProps("secondaryContactVMs.pager")}
                disabled={viewOnly}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <TextField
                label="Home Email"
                type="email"
                onChange={(e) => {
                  const value = e.target.value.trim();
                  formik.setFieldValue("secondaryContactVMs.homeEmail", value);

                  if (value && !emailRegex.test(value)) {
                    setSecHEmailErr(true)
                  }
                  else {
                    setSecHEmailErr(false)
                  }
                }}
                onBlur={formik.handleBlur}
                disabled={viewOnly}
              value={formik.values?.secondaryContactVMs?.homeEmail}

              />
            </div>
            {secHEmailErr &&
              <p className='mb-0 color-red'>
                Invalid Email Format
              </p>
            }
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <TextField
                label="Work Email "
                type="email"
                onChange={(e) => {
                  const value = e.target.value.trim();
                  formik.setFieldValue("secondaryContactVMs.workEmail", value);

                  if (value && !emailRegex.test(value)) {
                    setSecWEmailErr(true)
                  }
                  else {
                    setSecWEmailErr(false)
                  }
                }}
                onBlur={formik.handleBlur}
                disabled={viewOnly}
                value={formik.values?.secondaryContactVMs?.workEmail}

              />
            </div>
            {secWEmailErr &&
              <p className='mb-0 color-red'>
                Invalid Email Format
              </p>
            }
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <label className="input-label">Preferred Method
              </label>
              <Select
                styles={customStyles}
                className="select"
                options={getContactLookup?.result?.preferredMethodTypes?.map((option: any) => ({
                  label: option?.name,
                  value: option?.id
                }))}
                value={
                  formik.values?.secondaryContactVMs?.preferredMethod?.id
                    ? {
                      value: formik.values?.secondaryContactVMs?.preferredMethod?.id,
                      label: formik.values?.secondaryContactVMs?.preferredMethod?.name || '',
                    }
                    : null
                }
                isDisabled={viewOnly}
                onChange={(selectedOption: any) => {
                  formik.setFieldValue('secondaryContactVMs.preferredMethod.id', selectedOption.value);
                  formik.setFieldValue('secondaryContactVMs.preferredMethod.name', selectedOption.label);
                }}
              />
            </div>
          </div>
          <div className="col-md-6">
            <label className="input-label">
              Pref.Times
            </label>
            <TimePicker
              placeholder="Select Time"
              className="form-control datetimepicker-time"
              onChange={onChangeTimeSecondary}
              // value={aptResultbyId?.result?.startTime}
              defaultOpenValue={dayjs("12:00 AM", "h:mm A")}
              format="h:mm A"
              use12Hours
              disabled={viewOnly}
              value={
                formik.values?.secondaryContactVMs?.perferredTime &&
                  dayjs(formik.values?.secondaryContactVMs?.perferredTime, "h:mm A").isValid()
                  ? dayjs(formik.values?.secondaryContactVMs?.perferredTime, "h:mm A")
                  : null
              }
            />
          </div>
        </>
      }
    </div>
  )
}

export default ContactWizardData